import { to } from '../utils';
import BaseLasStrategy from './BaseLasStrategy';
import { ColorScheme } from './constants';
import lasRunner from './LasRunnerUtil';
import { triggerWithdrawPrincipal } from './api';
import ScLoanError from './utils/scLoanError';
import { UnityErrorResponse } from '../types/apiResponses/unityResponses';

class WithdrawStrategy extends BaseLasStrategy {
  async runInteraction() {
    if (this.interactionDetails.openPlatform) {
      await super.runInteraction();
    } else {
      const [err] = await to<any, UnityErrorResponse>(
        triggerWithdrawPrincipal(this.interactionToken, this.getLaunchUrl()),
      );
      if (err) throw new ScLoanError(err.message, err.code);
    }
  }
}

type WithdrawPrincipalArgs = {
  interactionToken?: string;
  /**
   * Optional AbortSignal to cancel an in-flight withdrawal.
   *
   * On abort the SDK confirms the final state with the backend (the same flow
   * as an in-app cancel). In the typical cancellation case this REJECTS with a
   * `ScLoanError` whose `.data` holds the interaction status, so handle it in
   * `.catch`. It resolves only if the backend reports the withdrawal actually
   * completed.
   */
  signal?: AbortSignal;
  /** `dark` | `light` | `system`, forwarded verbatim as the `theme` query param */
  colorScheme?: ColorScheme;
};
async function withdrawPrincipal({
  interactionToken,
  signal,
  colorScheme,
}: WithdrawPrincipalArgs = {}) {
  const intentStrategy = new WithdrawStrategy(interactionToken, {
    signal,
    colorScheme,
  });
  return lasRunner(intentStrategy);
}

export default withdrawPrincipal;
